import moment from 'moment'
import {objToMap} from './common-utils'

/**
 * Echart所需数据生成 [{value:xxx,name:xxx},]
 * @param {Array} keys
 * @param {Array} values
 */
export function parseValueName (keys, values) {
  let _array = []
  keys.forEach((key, index) => {
    let temp = {value: values[index], name: key}
    _array.push(temp)
  })
  return _array
}

/**
 * Echart所需数据生成 解析一个json对象为两个数组{keys:[], values:[]}
 * @param {*} obj
 * @param {optional:Map} map 对象属性:对应的值 (不传入map则直接取obj[attr]为key)
 */
export function parseTwoArray (obj, map) {
  map = map._c || ''
  let retObj = {keys: [], values: []}
  if (map) { // map指定排序，指定key
    map.forEach((value, key) => {
      retObj.keys.push(value)
      retObj.values.push(obj[key])
    })
  } else { // obj默认排序，默认key
    let objMap = objToMap(obj)._c
    for (var [key, value] of objMap) {
      retObj.keys.push(key)
      retObj.values.push(value)
    }
  }
  return retObj
}

/**
 * 追加排名
 * @param {Array} arr
 * @param {Array} ranks
 */
export function withRank (arr, ranks) {
  let _array = []
  arr.forEach((key, index) => {
    let temp = key + ' [排名：' + ranks[index] + ']'
    _array.push(temp)
  })
  return _array
}

/**
 * 从对象数组中，抽取指定一个属性的数组
 * @param {Object} objectArr
 * @param {string} attribute
 */
export function extractArrFromObj (objectArr, attribute) {
  let _array = []
  objectArr.forEach((object) => {
    _array.push(object[attribute])
  })
  return _array
}

/**
 * 从对象数组中，抽取指定多个属性的数组
 * @param {Object} objectArr
 * @param {Array} attributes
 * @param {boolean} noReverse 数组不翻转；默认为false(翻转)
 */
export function extractArrsFromObj (objectArr, attributes, noReverse) {
  let _object = {}
  attributes.forEach((attribute) => {
    let _arr = []
    if (noReverse) {
      _arr = extractArrFromObj(objectArr, attribute)
    } else {
      _arr = extractArrFromObj(objectArr, attribute).reverse()
    }
    _object[attribute] = _arr
  })
  return _object
}

/**
 *  最近一周
 */
export function getLastWeek () {
  var lastMonday = moment().day(1 - 7).format('YYYY-MM-DD')
  var lastSunday = moment().day(0).format('YYYY-MM-DD')
  return [lastMonday, lastSunday]
}

/**
 * 最近一月
 */
export function getLastMonth () {
  var lastMonthMonday = moment().day(1 - 4 * 7).format('YYYY-MM-DD')
  var lastSunday = moment().day(0).format('YYYY-MM-DD')
  return [lastMonthMonday, lastSunday]
}

/// formatters
/**
 * 柱状图Label自定义格式
 */
export function subLabel (string) {
  const len_ = 30
  return _subLabel(string, len_)
}

export function subLabelM (string) {
  const len_ = 15
  return _subLabel(string, len_)
}

function _subLabel (string, len_) {
  string = string.replace('[排名：', '[')
  let ScooId = string.indexOf('.') + 1
  let rankS = string.indexOf('[')
  let rankE = string.indexOf(']') + 1
  if (rankS > len_) {
    return string.substring(ScooId, len_).concat('...').concat(string.substring(rankS, rankE))
  } else {
    return string.substring(ScooId)
  }
}

/**
 * 自定义多层柱状图tooltip，显示总数
 */
export function tooltipWithSum (array) {
  let sum = 0
  let ret = ''
  ret += `${array[0].name}<br/>`
  array.forEach(t => {
    sum += t.data
    ret += `${t.marker} ${t.seriesName}： ${t.data}<br/>`
  })
  ret += `合计：${sum}`
  return ret
}

export function fromClub () {
  return window.location.search.indexOf('from=clubCRMP2Zyb209Y2x1YkNSTQ') > 0
}



// WEBPACK FOOTER //
// ./src/common/js/app-utils.js